import {
  Box,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import React from 'react';
import { StyledButton } from '../../../components/styles/StyledButtons';
import { ChatOAuthDialogState } from './settingsTypes';

interface ChatOAuthDialogProps {
  dialog: ChatOAuthDialogState | null;
  onClose: () => void;
}

function getDialogTitle(dialog: ChatOAuthDialogState): string {
  if (dialog.severity === 'success') {
    if (dialog.channel === 'teams') return 'Microsoft Teams connected';
    if (dialog.channel === 'slack') return 'Slack connected';
    return 'Google Chat connected';
  }
  if (dialog.channel === 'teams') return 'Microsoft Teams connection failed';
  if (dialog.channel === 'slack') return 'Slack connection failed';
  return 'Google Chat connection failed';
}

const ChatOAuthDialog: React.FC<ChatOAuthDialogProps> = ({ dialog, onClose }) => (
  <Dialog open={dialog?.open ?? false} onClose={onClose} maxWidth="sm" fullWidth>
    <DialogTitle>{dialog ? getDialogTitle(dialog) : ''}</DialogTitle>
    <DialogContent>
      <Typography>{dialog?.message}</Typography>
    </DialogContent>
    <DialogActions>
      <StyledButton onClick={onClose}>OK</StyledButton>
    </DialogActions>
  </Dialog>
);

export default ChatOAuthDialog;
